"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

var _drawerMainMenuDivider = _interopRequireDefault(require("./drawer-main-menu-divider"));

var _menuItem = require("./menu-item");

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _wrapperContext = _interopRequireDefault(require("../../../context/wrapper-context"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _goToHelper = require("@eig-builder/core-utils/helpers/go-to-helper");

var _getClassNameHelper = _interopRequireDefault(require("./../helpers/get-class-name-helper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Drawer main menu item - one item in the list
 *
 * @class DrawerMainMenuItem
 * @extends {Component}
 * @param title - displayed title
 * @param link - string
 * @param tag - analytics / ui testing tag
 * @param propertyType - property type used for analytics / ui testing tag
 * @param activeOnlyWhenExact - only display as active when the urls is a exact match
 * @param hideForFreeAccount - only display when the user has a free account
 * @param hideForPaidAccount - only display when the user has a paid account
 * @param visible - only display when visible
 * @param isFreeAccount - is the user a free or paid account
 * @param toggleDrawer - toggles the drawer
 * @param subItems - item can have sub menu items
 * @param nested - nested (sub) menu item
 * @param isExternal - opens the link in a new tab/window, based on the target property
 */
var DrawerMainMenuItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DrawerMainMenuItem, _Component);

  var _super = _createSuper(DrawerMainMenuItem);

  function DrawerMainMenuItem(props, _context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrawerMainMenuItem);
    _this = _super.call(this, props, _context);

    _this.dontSetClasses = function () {
      try {
        return window.localStorage && window.localStorage.getItem('activeMenuItemWithChildren');
      } catch (ex) {
        return false;
      }
    };

    _this.initCollapseMenuItem = function (context) {
      var _this$props = _this.props,
          basePath = _this$props.basePath,
          link = _this$props.link,
          subItems = _this$props.subItems,
          tag = _this$props.tag;
      var hasNoSubItems = (0, _isEmpty["default"])(subItems);

      if (hasNoSubItems) {
        return;
      }

      var open = false; // Check first for main parent path

      var currentItemActive = (0, _reactRouter.matchPath)(window.location.pathname, basePath || link);

      if (currentItemActive) {
        context.setCurrentDrawerItem(link);
        open = true;
      } else {
        // Otherwise check if one of the subitems is active
        subItems.map(function (item) {
          var active = (0, _reactRouter.matchPath)(window.location.pathname, item.basePath || item.link);

          if (active) {
            context.setCurrentDrawerItem(item.link);
            open = true;

            try {
              // Set current item again for the fakenav
              window.localStorage && window.localStorage.setItem('activeMenuItemWithChildren', (0, _snakeCase["default"])(_this.props.tag));
            } catch (ex) {}
          }
        });
      }

      try {
        // This is for the fakenav, to determine if we need to open or close the menu item
        var activeMenuItemWithChildren = window.localStorage && window.localStorage.getItem('activeMenuItemWithChildren');

        if (activeMenuItemWithChildren && (0, _snakeCase["default"])(tag) === activeMenuItemWithChildren) {
          return true;
        }
      } catch (ex) {}

      return open;
    };

    _this.handleOnClick = function (item) {
      return function () {
        if (_this.props.isMobile || _this.props.toggleDrawerOnClick) {
          _this.props.toggleDrawer();
        }

        if (item.isExternal || !_this.context.history) {
          window.open(item.link, item.target);
          return;
        }

        (0, _goToHelper.goToWithHistory)(_this.context.history, _this.props.link); // Remove state from localstorage when navigating. We want to close the collapsable item when navigating to another page

        window.localStorage && window.localStorage.removeItem('activeMenuItemWithChildren');
      };
    };

    _this.handleOnClickMenuItem = function () {
      var hasSubItems = !(0, _isEmpty["default"])(_this.props.subItems);

      if (hasSubItems) {
        // Open item on click when the current state is closed
        if (!_this.state.open) {
          _this.handleOpenItem();
        } // Navigate to the link


        if (_this.props.link) {
          if (!_this.context.history) {
            window.open(_this.props.link);
          } else {
            (0, _goToHelper.goToWithHistory)(_this.context.history, _this.props.link);
          }
        }
      }
    };

    _this.handleOpenItem = function () {
      try {
        var newValue = !_this.state.open;

        if (newValue) {
          window.localStorage && window.localStorage.setItem('activeMenuItemWithChildren', (0, _snakeCase["default"])(_this.props.tag));
        } else {
          window.localStorage && window.localStorage.removeItem('activeMenuItemWithChildren');
        }
      } catch (ex) {}

      _this.setState({
        open: !_this.state.open
      });
    };

    _this.onIconClick = function () {};

    _this.onToggleExpandClick = function (event) {
      _this.handleOpenItem();

      event.preventDefault();
    };

    _this.getMenuItem = function (hasSubItems) {
      var _this$props2 = _this.props,
          nested = _this$props2.nested,
          basePath = _this$props2.basePath,
          link = _this$props2.link;
      var active = (0, _reactRouter.matchPath)(basePath || link, window.location.pathname);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _getClassNameHelper["default"])('', _this.props)
      }, /*#__PURE__*/_react["default"].createElement(_menuItem.MainMenuItem, {
        hasSubItems: hasSubItems,
        basePath: basePath,
        active: active,
        nested: nested,
        onClick: _this.handleOnClickMenuItem,
        onIconClick: _this.onIconClick,
        onToggleExpandClick: _this.onToggleExpandClick,
        linkToIcon: _this.props.linkToIcon,
        materialIconTag: _this.props.materialIconTag,
        link: _this.props.link,
        title: _this.props.title,
        open: _this.state.open,
        tag: _this.props.tag,
        classes: _this.props.classes
      }), hasSubItems && /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
        "in": _this.state.open,
        timeout: "auto",
        className: _this.state.dontSetClasses ? null : 'menu-item-with-children-' + (0, _snakeCase["default"])(_this.props.tag)
      }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
        component: "div",
        disablePadding: true,
        dense: true
      }, _this.props.subItems.map(function (item, index) {
        if (item.divider) {
          return item.visible ? /*#__PURE__*/_react["default"].createElement(_drawerMainMenuDivider["default"], {
            key: index
          }) : null;
        }

        var active = item.link === _this.context.currentDrawerItem;
        var hasVisibleProp = !(0, _isNil["default"])(item.visible);
        return /*#__PURE__*/_react["default"].createElement(DrawerMainMenuItem, {
          nested: true,
          link: item.link,
          title: item.title,
          tag: item.tag,
          materialIconTag: item.materialIconTag,
          key: item.tag + item.link,
          active: !!active,
          toggleDrawer: _this.props.toggleDrawer,
          history: _this.context.history,
          visible: hasVisibleProp ? item.visible : true,
          basePath: item.basePath,
          classes: item.classes
        });
      }))));
    };

    _this.state = {
      open: _this.initCollapseMenuItem(_context),
      dontSetClasses: _this.dontSetClasses()
    };
    return _this;
  }

  (0, _createClass2["default"])(DrawerMainMenuItem, [{
    key: "render",
    value: function render() {
      if (!this.props.visible) {
        return null;
      }

      if ((0, _isBoolean["default"])(this.props.hideForFreeAccount) && this.props.hideForFreeAccount && this.props.isFreeAccount) {
        return null;
      } else if ((0, _isBoolean["default"])(this.props.hideForPaidAccount) && this.props.hideForPaidAccount && !this.props.isFreeAccount) {
        return null;
      }

      var hasSubItems = !(0, _isEmpty["default"])(this.props.subItems);
      return hasSubItems ? this.getMenuItem(hasSubItems) : /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        onClick: this.handleOnClick(this.props),
        target: this.props.target
      }, (0, _taggingHelper.getDataProperty)({
        dataElementType: _taggingHelper.DataElementTypes.MENUITEM,
        dataElementLocation: _taggingHelper.DataElementLocations.LEFT_RAIL,
        dataElementLabel: this.props.tag,
        dataElementId: 'main-menu-item-' + this.props.tag
      })), this.getMenuItem(hasSubItems));
    }
  }]);
  return DrawerMainMenuItem;
}(_react.Component);

DrawerMainMenuItem.contextType = _wrapperContext["default"];
DrawerMainMenuItem.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  link: _propTypes["default"].string,
  tag: _propTypes["default"].string.isRequired,
  isMobile: _propTypes["default"].bool.isRequired,
  toggleDrawerOnClick: _propTypes["default"].bool,
  materialIconTag: _propTypes["default"].string,
  classes: _propTypes["default"].string,
  linkToIcon: _propTypes["default"].string,
  toggleDrawer: _propTypes["default"].func,
  hideForFreeAccount: _propTypes["default"].bool,
  hideForPaidAccount: _propTypes["default"].bool,
  visible: _propTypes["default"].bool,
  target: _propTypes["default"].string,
  isFreeAccount: _propTypes["default"].bool,
  subItems: _propTypes["default"].array,
  nested: _propTypes["default"].bool,
  isExternal: _propTypes["default"].bool,
  basePath: _propTypes["default"].string,
  history: _propTypes["default"].object
};
DrawerMainMenuItem.defaultProps = {
  propertyType: 'main_menu',
  hideForFreeAccount: false,
  hideForPaidAccount: false,
  visible: true,
  target: ''
};
var _default = DrawerMainMenuItem;
exports["default"] = _default;